import { render, staticRenderFns } from "./userReport.vue?vue&type=template&id=49f0c798&scoped=true&"
import script from "./userReport.vue?vue&type=script&lang=js&"
export * from "./userReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f0c798",
  null
  
)

export default component.exports